<template>
  <anchor-modal
    v-model="display"
    width="70%"
    :title="title"
    light
    header-color="white"
    :header-split="true"
  >
    <users-form
      v-if="display"
      ref="form"
      @cancel="() => display = false"
      @success="successHandler"
    />
  </anchor-modal>
</template>

<script>
import UsersForm from './UsersForm';


export default {
  name: 'AdminUsersForm',
  components: {
    UsersForm,
  },
  data: () => ({
    display: false,
    title: '',
  }),
  methods: {
    open(user) {
      this.display = true;
      this.title = user ? 'Edit User' : 'Add New User';
      this.$nextTick(() => {
        this.$refs.form.setModel(user);
      });
    },
    successHandler() {
      this.$emit('success');
      this.display = false;
    },
  },
};
</script>
